import { NavLink } from 'react-router-dom';
import './Navbar.css';

const Navbar: React.FC = () => {

      return (
    <header className="header">
      <nav className="nav">
        <ul className="nav-list">
          <li className="nav-item">
            <NavLink
              to="/"
              className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}
            >
              Home
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink
              to="/CsvToJson"
              className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}
            >
              CsvToJson
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink
              to="/Table"
              className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}
            >
              Transaction Table
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink
              to="/FilteredItems"
              className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}
            >
              Filtered Items
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink
              to="/Expenses"
              className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}
            >
              Filtered Expenses Details
            </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                to="/BusinessExpenses"
                className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}
              >
                Business Expenses
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                to="/ExpenseBreakout"
                className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}
              >
                Expense Breakout
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                to="/BalanceSheet"
                className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}
              >
                Balance Sheet
              </NavLink>
            </li>
                    
        </ul>
      </nav>
    </header>
  );
};


export default Navbar;